/* eslint-disable import/prefer-default-export */

/**
 * inspects visibility of passed element to see if it has been hidden by an
 * adblock extension.
 *
 * @export
 * @param {Object} el DOM element to examine
 * @returns {Boolean} true if element is visible; false if blocked/hidden
 */
export function detectElement(el) {
  const isZeroHeight = el.clientHeight === 0;
  const isHidden =
    window.getComputedStyle(el).getPropertyValue('display') === 'none';

  return isZeroHeight || isHidden;
}
